import React from 'react';
import {FormattedMessage} from 'react-intl';
import config from '../../../config';
import logo from '../../../res/images/ic_neosvoc-logo-white.svg';
import messages from '../../../res/translations/messages';
import LanguageSwitcher from './LanguageSwitcher';

const Footer = () => (
    <div className="footer d-print-none">
        <div className="container">
            <div className="row align-items-center">
                <div className="col-auto">
                    <a href="https://www.neosvoc.com/" target="_blank" rel="noopener noreferrer">
                        <img src={logo} alt="NeosVoc" width="36" height="36" title="NeosVoc" />
                    </a>
                    <LanguageSwitcher />
                </div>
                <div className="col text-center">
                    <a href="mailto:info@neosvoc.com"><FormattedMessage {...messages.footer.support} /></a>
                </div>
                <div className="col-auto">
                    {config.environment !== 'prod' && <span className="environment">{config.environment}</span>}
                    &copy;2021 NeosVoc
                </div>
            </div>
        </div>
    </div>
);

export default Footer;
